import { FC } from 'react';
import { SVGIconProps } from './types';

const SVGIconEditPen: FC<SVGIconProps> = ({
  width = 16,
  height = 16,
  stroke = '#171717',
  strokeWidth = 1.67
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5089 2.73277L13.2533 5.47722M11.6732 1.56839C12.4311 0.810535 13.6598 0.810535 14.4177 1.56839C15.1756 2.32625 15.1756 3.55499 14.4177 4.31284L3.73054 15H1.01367V12.228L11.6732 1.56839Z"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SVGIconEditPen;
